import BreadcrumbTitle from "components/BreadcrumbTitle"
import PageMetaTags from "components/PageMetaTags"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Col,
  Container,
  Nav,
  Row,
  TabContent,
  TabPane,
  NavLink,
  Card,
  CardBody,
  Modal,
  Spinner,
} from "reactstrap"
import { FormSection, getFormValues, initialize, reduxForm } from "redux-form"
import {
  getInboxSetup,
  getListScreenSetup,
  getVendorConfig,
  updateListScreenSetup,
} from "store/actions"
import BackgroundTab from "./backgroundTab"
import BottomMenuTab from "./bottomMenuTab"
import CategoriesTab from "./categoriesTab"
import HeaderTab from "./headerTab"
import LayoutTab from "./layoutTab"
import { mapApiResponseToForm, mapFormToApi } from "./utils"

const ListScreen = ({
  vendorId,
  getListScreenSetup,
  listScreenSetup,
  initializeForm,
  getVendorConfig,
  vendorConfig,
  inboxSetup,
  getInboxSetup,
  loading,
  formValues,
  updateListScreenSetup,
  userId,
}) => {
  useEffect(() => {
    if (vendorId) {
      getListScreenSetup({ vendorId: vendorId })
      getVendorConfig({ id: vendorId })
      getInboxSetup({})
    }
  }, [vendorId])

  useEffect(() => {
    if (listScreenSetup && vendorConfig && inboxSetup) {
      initializeForm(
        mapApiResponseToForm({
          ...listScreenSetup,
          categorize_experiences: vendorConfig?.categorize_experiences,
          app_user_list: vendorConfig?.app_user_list,
          contact_us: vendorConfig?.contact_us,
          app_wide_private_message: vendorConfig?.app_wide_private_message,
          app_notifications_enabled: vendorConfig?.app_notifications_enabled,
          qr_text_code: vendorConfig?.qr_text_code,
          inbox_template_id: inboxSetup?.template_id,
          news_feed_enabled: vendorConfig?.news_feed_enabled,
        })
      )
    }
  }, [listScreenSetup, vendorConfig, inboxSetup])

  const TABS = {
    CATEGORIES: 1,
    LAYOUTS: 2,
    BACKGROUND: 3,
    HEADER: 4,
    BOTTOM_MENU: 5,
  }
  const [activeTab, setActiveTab] = useState(TABS.CATEGORIES)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  const renderBreadcrumbItem = () => {
    switch (activeTab) {
      case 1:
        return "Categories"
      case 2:
        return "Layout"
      case 3:
        return "Background"
      case 4:
        return "Header"
      case 5:
        return "Bottom Menu"
      default:
        return
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="List Screen" />
        <Container fluid>
          <BreadcrumbTitle
            title="List Screen"
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "List Screen",
                type: "tab",
                clickHandler: () => setActiveTab(TABS.CATEGORIES),
              },
              { title: renderBreadcrumbItem() },
            ]}
          />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Nav pills tabs>
                    <NavLink
                      className={markIfIsActive(TABS.CATEGORIES)}
                      onClick={() => setActiveTab(TABS.CATEGORIES)}
                    >
                      {<span style={{ fontSize: "16px" }}>Categories</span>}
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.LAYOUTS)}
                      onClick={() => setActiveTab(TABS.LAYOUTS)}
                    >
                      {<span style={{ fontSize: "16px" }}>Layout</span>}
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.BACKGROUND)}
                      onClick={() => setActiveTab(TABS.BACKGROUND)}
                    >
                      {<span style={{ fontSize: "16px" }}>Background</span>}
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.HEADER)}
                      onClick={() => setActiveTab(TABS.HEADER)}
                    >
                      {<span style={{ fontSize: "16px" }}>Header</span>}
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.BOTTOM_MENU)}
                      onClick={() => setActiveTab(TABS.BOTTOM_MENU)}
                    >
                      {<span style={{ fontSize: "16px" }}>Bottom Menu</span>}
                    </NavLink>
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId={TABS.CATEGORIES}>
                      <FormSection name="categories">
                        <CategoriesTab
                          tabIsActive={activeTab === TABS.CATEGORIES}
                          handleNext={() => setActiveTab(TABS.LAYOUTS)}
                        />
                      </FormSection>
                    </TabPane>
                    <TabPane tabId={TABS.LAYOUTS}>
                      <FormSection name="layout">
                        <LayoutTab
                          tabIsActive={activeTab === TABS.LAYOUTS}
                          handleNext={() => setActiveTab(TABS.BACKGROUND)}
                          handleBack={() => setActiveTab(TABS.CATEGORIES)}
                        />
                      </FormSection>
                    </TabPane>
                    <TabPane tabId={TABS.BACKGROUND}>
                      <FormSection name="background">
                        <BackgroundTab
                          tabIsActive={activeTab === TABS.BACKGROUND}
                          handleNext={() => setActiveTab(TABS.HEADER)}
                          handleBack={() => setActiveTab(TABS.LAYOUTS)}
                        />
                      </FormSection>
                    </TabPane>
                    <TabPane tabId={TABS.HEADER}>
                      <FormSection name="header">
                        <HeaderTab
                          tabIsActive={activeTab === TABS.HEADER}
                          handleNext={() => setActiveTab(TABS.BOTTOM_MENU)}
                          handleBack={() => setActiveTab(TABS.BACKGROUND)}
                        />
                      </FormSection>
                    </TabPane>
                    <TabPane tabId={TABS.BOTTOM_MENU}>
                      <FormSection name="bottomMenu">
                        <BottomMenuTab
                          tabIsActive={activeTab === TABS.BOTTOM_MENU}
                          handleBack={() => setActiveTab(TABS.HEADER)}
                        />
                      </FormSection>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal isOpen={loading} centered={true} size="sm">
        <CardBody className={"p-2 my-1 text-center"}>
          <Spinner className="ms-2" color="primary" />
        </CardBody>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  formValues: getFormValues(FORM_NAMES.LIST_SCREEN)(state),
  vendorId: state.Login.vendorId,
  listScreenSetup: state.ListScreen.listScreenSetup,
  vendorConfig: state.clients.vendorConfig,
  inboxSetup: state.ListScreen.inboxSetup,
  loading: state.ListScreen.loading,
  userId: state.Login.authUser.id,
})

const mapDispatchToProps = dispatch => ({
  getListScreenSetup: values => dispatch(getListScreenSetup(values)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.LIST_SCREEN, values)),
  getVendorConfig: values => dispatch(getVendorConfig(values)),
  getInboxSetup: values => dispatch(getInboxSetup(values)),
  updateListScreenSetup: values => dispatch(updateListScreenSetup(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.LIST_SCREEN })(ListScreen))
